import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKURelations( variable_id ) {

   const edition_id = useAZZKULatestEditionID();

   return useFetchData({
      APIMethod: API.getAZZKURelations,
      condition: !!edition_id && !!variable_id,
      debounce: true,
      params: [ edition_id, variable_id ],
      resultDataHandler: data => data.map( item => ({
         value: item.id,
         label: item.name
      }))
   })
}